import { RouteObject } from "react-router-dom";
import { PageNotFound } from "../app/404";
import { LandingPage } from "../app/_website";
import { FindEventsPage } from "../app/_website/find-events";
import { PricingPage } from "../app/_website/pricing";
import { ErrorPage } from "../app/error";
import { PreviewSingleEvent } from "../app/events/preview";
import { LegalPage } from "../app/legal";
import { Layout } from "../components/layout/layout";

export const websiteRouter: RouteObject[] = [
  {
    path: "/",
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        path: "",
        element: (
          <Layout>
            <LandingPage />
          </Layout>
        ),
      },
      {
        path: "find-events",
        element: (
          <Layout>
            <FindEventsPage />
          </Layout>
        ),
      },
      {
        path: "pricing",
        element: (
          <Layout>
            <PricingPage />
          </Layout>
        ),
      },
      {
        path: "legal/:doc",
        element: (
          <Layout footerClassName="mt-10">
            <LegalPage className="max-width-website" />
          </Layout>
        ),
      },
      {
        path: "404",
        element: (
          <Layout>
            <div className="max-width-website flex items-center">
              <PageNotFound />
            </div>
          </Layout>
        ),
      },
      {
        path: ":slug",
        element: (
          <Layout>
            <div className="max-width-website py-10">
              <PreviewSingleEvent canBuy />
            </div>
          </Layout>
        ),
      },
    ],
  },
  {
    path: "*",
    element: (
      <Layout>
        <div className="max-width-website flex items-center">
          <PageNotFound />
        </div>
      </Layout>
    ),
  },
];
